module.exports = __webpack_public_path__ + "img/tree-09-e-trunk.0e408a67.png";